import { render, staticRenderFns } from "./TrangXemHoSoCanBo.vue?vue&type=template&id=c3d2edec&"
import script from "./TrangXemHoSoCanBo.vue?vue&type=script&lang=js&"
export * from "./TrangXemHoSoCanBo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports